import $i from "~/i18n";
import * as actions from "./actions";
import * as mutations from "./mutations";

export default {
    namespaced: true,
    state: () => ({
        posts: [],
        post: null,
        uploadPercentage: 0,
        allPosts: [],
        form: {
            img: '',
            title: "",
            content: "",
            imgSrc: "",
            description: "",
            subcategory_id: null,
            category_id: null,
            pdf: null,
            as_draft: false
        },
    }),
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/blog/index.js